import { restfulIO } from "./endpoint";
import { AttributesMixin, define, Model } from "@type-r/models";

export interface ImportJobDetails extends AttributesMixin<typeof ImportJobDetails> { }
@define
export class ImportJobDetails extends Model {
  static endpoint = restfulIO('api/v1/ingest/import-jobs');

  static attributes = {
    assetTypeId: Number,
    statusId: Number,
    documentId: String,
    importTemplateId: String
  }
}
